import React from "react";
import { ProductForm } from "../../../../components/admin/product/ProductForm";

export const CreateProduct = () => {
    return (
        <>
            <ProductForm />
        </>
    )
};
